import React from 'react'
import useBreakpoint from '#src/hooks/useBreakpoint'
import FeedbackForm from './FeedbackForm'
import { FancyModal, FancyContent, ModalTitle, ModalContent } from '@deal/components'
import FlyoutMenu from '#src/components/FlyoutMenu'
import styles from './styles.css'

interface FeedbackPopupProps {
  isOpen: boolean
  onRequestClose: () => void
  sourceKey: Tracking.FeedbackSourceKey
}

const FeedbackPopup: React.SFC<FeedbackPopupProps> = ({ isOpen, onRequestClose, sourceKey }) => {
  const isMobile = !useBreakpoint('sm')
  return isMobile ? (
    <FancyModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.container}
      overlayClassName={styles.container}
    >
      <FancyContent>
        <ModalTitle>Give us feedback</ModalTitle>
        <ModalContent>
          <FeedbackForm onRequestClose={onRequestClose} sourceKey={sourceKey} />
        </ModalContent>
      </FancyContent>
    </FancyModal>
  ) : (
    <FlyoutMenu
      open={isOpen}
      onClose={onRequestClose}
      from="right"
      title="Give us feedback"
      overlayClassName={styles.overlayClass}
      menuClassName={styles.menuClass}
    >
      <FeedbackForm onRequestClose={onRequestClose} sourceKey={sourceKey} />
    </FlyoutMenu>
  )
}

export default FeedbackPopup
